import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Button,
  Box
} from '@mui/material';

import LinkIcon from '@mui/icons-material/Link';
import NotesIcon from '@mui/icons-material/Notes';

export default function AdditionalInputsSection({
  onWebLinksUpload,
  onCustomNotesUpload
}) {
  const handleFileUpload = (callback) => (e) => {
    const file = e.target.files[0];
    if (file?.type === 'text/plain') {
      const reader = new FileReader();
      reader.onload = (e) => callback(e.target.result);
      reader.readAsText(file);
    }
  };

  const downloadTemplate = (filename, content) => {
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Card sx={{ mb: 6 }}>
      <CardHeader title="Additional Inputs" sx={{ backgroundColor: '#f5f5f5' }} />
      <CardContent>
        <Grid container spacing={4}>

          {/* Web Links */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center' }}>
              <LinkIcon sx={{ mr: 1 }} /> Web Links
            </Typography>
            <Box mt={1} display="flex" gap={2}>
              <Button variant="outlined" component="label">
                Upload .txt File
                <input type="file" hidden onChange={handleFileUpload(onWebLinksUpload)} accept=".txt" />
              </Button>
              <Button
                variant="text"
                onClick={() =>
                  downloadTemplate(
                    'web_links_template.txt',
                    'https://www.uptodate.com/contents/diabetes-type-2\nhttps://www.cdc.gov/hypertension/'
                  )
                }
              >
                Download Template
              </Button>
            </Box>
          </Grid>

          {/* Custom Notes */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center' }}>
              <NotesIcon sx={{ mr: 1 }} /> Additional Notes
            </Typography>
            <Box mt={1} display="flex" gap={2}>
              <Button variant="outlined" component="label">
                Upload .txt File
                <input type="file" hidden onChange={handleFileUpload(onCustomNotesUpload)} accept=".txt" />
              </Button>
              <Button
                variant="text"
                onClick={() =>
                  downloadTemplate(
                    'additional_notes_template.txt',
                    'Patient with mobility limitations. Avoid multiple visits in one week. Requires sign language interpreter.'
                  )
                }
              >
                Download Template
              </Button>
            </Box>
          </Grid>

        </Grid>
      </CardContent>
    </Card>
  );
}
